import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import * as Yup from "yup";

import AuthFrame from "@components/AuthFrame";
import AuthenticationService from "@services/Authentication";
import { notifyTimeout, notifyDisabledUser } from "@store/modules/auth";
import AuthTemplate from "@templates/Auth";

const useStyles = makeStyles((theme) => ({
  paper: {
    maxWidth: "100%",
    "@media all and (min-width: 768px)": {
      width: "320px",
    },
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: "#660099",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(2, 0, 0),
  },
  code: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    marginTop: theme.spacing(2),
  },
  codeLink: {
    color: "#3f51b5!important",
    cursor: "pointer",
    textDecoration: "none!important",
  },
}));

function Login(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const [loading, setLoading] = useState(false);

  let loginInputRef = null;

  function handleSubmit(values) {
    if (loading) {
      return;
    }
    setLoading(true);
    AuthenticationService.forgotPassword(values.login)
      .then(() => {
        setLoading(false);
        toast.success("Verifique seu e-mail!");
        history.push("/codigo-senha");
      })
      .catch((e) => {
        console.log(e.message);
        if (
          e.message === "User password cannot be reset in the current state."
        ) {
          toast.warn(
            "Não é possível recuperar a senha no status atual do usuário!"
          );
        } else if (
          e.message === "Attempt limit exceeded, please try after some time."
        ) {
          toast.warn(
            "Limite de tentativas excedido. Por favor, tente mais tarde!"
          );
        } else {
          toast.error("Falha ao recuperar senha!");
        }
        setLoading(false);
      });
  }

  const timeoutNotification = useSelector(
    (state) => state.auth.timeoutNotification
  );
  const disabledUserNotification = useSelector(
    (state) => state.auth.disabledUserNotification
  );

  useEffect(() => {
    function showSessionExpiredAlert() {
      toast.warn("Tempo de sessão expirado!");
      dispatch(notifyTimeout(false));
    }

    function showDisabledUserAlert() {
      toast.warn("Acesso negado!");
      dispatch(notifyDisabledUser(false));
    }

    if (timeoutNotification) {
      showSessionExpiredAlert();
    }

    if (disabledUserNotification) {
      showDisabledUserAlert();
    }
  }, [timeoutNotification, disabledUserNotification, dispatch]);

  const initialValues = {
    login: "",
  };
  const validationSchema = Yup.object().shape({
    login: Yup.string().required("Campo obrigatório"),
  });

  return (
    <AuthTemplate>
      <AuthFrame banner="right">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          isInitialValid={false}
        >
          {({ errors, touched, isValid, values, handleChange, handleBlur }) => (
            <div className={classes.paper}>
              <Typography component="h1" variant="h5">
                Esqueceu a senha
              </Typography>
              {/* login input */}
              <TextField
                value={values.login}
                onChange={handleChange}
                onBlur={handleBlur}
                helperText={touched.login ? errors.login : ""}
                error={touched.login && Boolean(errors.login)}
                variant="outlined"
                margin="normal"
                fullWidth
                required
                id="login"
                label="Usuário"
                name="login"
                autoComplete="login"
                onKeyPress={(e) => {
                  if (e.key === "Enter" && loginInputRef) {
                    loginInputRef.focus();
                  }
                }}
              />
              {/* end login input */}

              {/* submit button */}
              <Button
                onClick={() => {
                  handleSubmit(values);
                }}
                fullWidth
                variant="contained"
                color="primary"
                size="large"
                className={classes.submit}
                disabled={!isValid || loading}
              >
                Enviar
              </Button>
              {/* end submit button */}
            </div>
          )}
        </Formik>
        <div className={classes.code}>
          <Link to="/codigo-senha" className={classes.codeLink}>
            <Typography>Digite o código</Typography>
          </Link>
        </div>
      </AuthFrame>
    </AuthTemplate>
  );
}

export default Login;
